import React from "react";
import Footer from "../../components/layout/Footer";
import { privacySections } from "../../data/privacy/privacyData";
import PrivacyNav from "./sections/PrivacyNav";
import PrivacyHeader from "./sections/PrivacyHeader";
import PrivacyContent from "./sections/PrivacyContent";

export default function PrivacyPage() {
  return (
    <>
      <PrivacyNav />
      <div className="min-h-screen bg-white py-12">
        <div className="max-w-3xl mx-auto px-4">
          <PrivacyHeader sections={privacySections} />
          <PrivacyContent sections={privacySections} />
        </div>
      </div>
      <Footer />
    </>
  );
}
